import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import "./sidebar.css";
import Logo from "../../assets/images/logo.svg";
import dashIcon from "../../assets/images/dash-icon.svg";
import dashIconBlack from "../../assets/images/dash-iconBlack.svg";

import patientsIcon from "../../assets/images/patients-icon.svg";
import patientsIconBlue from "../../assets/images/patients-iconBlue.svg";

import doctorIcon from "../../assets/images/doctor-icon.svg";
import doctorIconBlue from "../../assets/images/doctor-iconBlue.svg";

import docIcon from "../../assets/images/doc-icon.svg";
import docIconBlue from "../../assets/images/doc-iconBlue.svg";

import logsIcon from "../../assets/images/logs-icon.svg";
import logsIconBlue from "../../assets/images/logs-blue.svg";

import supportIcon from "../../assets/images/support-icon.svg";
import supportIconBlue from "../../assets/images/support-iconBlue.svg";

import logoutIcon from "../../assets/images/logout.svg";
import { logoutUser } from "../../store/authActions";

const Sidebar = ({ collapsed, mobileOpen, onClose }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openMenu, setOpenMenu] = useState("");
  const [isHover, setIsHover] = useState(false);
  const [loading, setLoading] = useState(false);
  const isExpanded = !collapsed || isHover;
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    onCloseRef.current?.();
  }, [location.pathname]);

  const toggleMenu = (menu) => {
    if (!isExpanded) return;
    setOpenMenu((prev) => (prev === menu ? "" : menu));
  };

  const openOnHover = (menu) => {
    if (collapsed) {
      setIsHover(true); // ⭐ IMPORTANT
      setOpenMenu(menu);
    }
  };

  const handleLogout = async () => {
    try {
      setLoading(true);
      await dispatch(logoutUser());
    } finally {
      setLoading(false);
      navigate("/login");
    }
  };

  return (
    <div
      className={`sidebar ${collapsed ? "collapsed" : ""} ${
        isHover ? "hover-open" : ""
      } ${mobileOpen ? "mobile-open" : ""}`}
      onMouseEnter={() => collapsed && setIsHover(true)}
      onMouseLeave={() => {
        if (collapsed) {
          setIsHover(false);
          setOpenMenu("");
        }
      }}
    >
      {/* LOGO */}
      <div className="logo">
        <img src={Logo} alt="NCML" className="logo-img" />
      </div>

      <ul className="menu">
        {/* <li className="menu-title">Dashboards</li> */}

        <li>
          <NavLink
            to="/dashboard"
            className={({ isActive }) =>
              `menu-item ${isActive ? "active" : ""}`
            }
          >
            {({ isActive }) => (
              <>
                <img
                  src={isActive ? dashIcon : dashIconBlack}
                  className="menu-icon-img"
                  alt="dashboard"
                />
                {isExpanded && <span className="menu-text">Dashboard</span>}
              </>
            )}
          </NavLink>
        </li>

        {/* <li className="menu-title">Pages</li> */}

        {/* MASTER */}

        <li>
          <NavLink
            to="/patients"
            className={({ isActive }) =>
              `menu-item ${isActive ? "active" : ""}`
            }
          >
            {({ isActive }) => (
              <>
                <img
                  src={isActive ? patientsIconBlue : patientsIcon}
                  className="menu-icon-img"
                  alt="patients"
                />
                {isExpanded && <span className="menu-text">Patients</span>}
              </>
            )}
          </NavLink>
        </li>

        {/* TRANSACTION */}

        <li>
          <NavLink
            to="/doctors-kyc"
            className={({ isActive }) =>
              `menu-item ${isActive ? "active" : ""}`
            }
          >
            {/* <img src={doctorIcon} className="menu-icon-img" />
            {isExpanded && <span className="menu-text">Doctors & KYC</span>} */}
            {({ isActive }) => (
              <>
                <img
                  src={isActive ? doctorIconBlue : doctorIcon}
                  className="menu-icon-img"
                  alt="doctor"
                />
                {isExpanded && <span className="menu-text">Doctors & KYC</span>}
              </>
            )}
          </NavLink>
        </li>

        {/* REPORT */}

        <li>
          <NavLink
            to="/document"
            className={({ isActive }) =>
              `menu-item ${isActive ? "active" : ""}`
            }
          >
            {/* <img src={docIcon} className="menu-icon-img" />
            {isExpanded && <span className="menu-text">Documents</span>} */}
            {({ isActive }) => (
              <>
                <img
                  src={isActive ? docIconBlue : docIcon}
                  className="menu-icon-img"
                  alt="documents"
                />
                {isExpanded && <span className="menu-text">Documents</span>}
              </>
            )}
          </NavLink>
        </li>

        {/* IMPORT & EXPORT */}

        <li>
          <NavLink
            to="/locker-and-sharing"
            className={({ isActive }) =>
              `menu-item ${isActive ? "active" : ""}`
            }
          >
            {/* <img src={logsIcon} className="menu-icon-img" />
            {isExpanded && <span className="menu-text">Logs & Activity</span>} */}
            {({ isActive }) => (
              <>
                <img
                  src={isActive ? logsIconBlue : logsIcon}
                  className="menu-icon-img"
                  alt="logsActivity"
                />
                {isExpanded && (
                  <span className="menu-text">Logs & Activity</span>
                )}
              </>
            )}
          </NavLink>
        </li>

        {/* SYS ADMIN */}

        <li>
          <NavLink
            to="/support-and-assistance"
            className={({ isActive }) =>
              `menu-item ${isActive ? "active" : ""}`
            }
          >
            {/* <img src={supportIcon} className="menu-icon-img" />
            {isExpanded && <span className="menu-text">Support Tickets</span>} */}
            {({ isActive }) => (
              <>
                <img
                  src={isActive ? supportIconBlue : supportIcon}
                  className="menu-icon-img"
                  alt="support"
                />
                {isExpanded && (
                  <span className="menu-text">Support Tickets</span>
                )}
              </>
            )}
          </NavLink>
        </li>
      </ul>

      {/* FOOTER */}
      {isExpanded && (
        <div className="sidebar-footer">
          {/* <img src={manishImage} alt="user" className="user-img" /> */}
          <ul className="menu">
            <li>
              <div
                className="menu-item has-dropdown"
                onClick={!loading ? handleLogout : undefined}
              >
                <div className="menu-left">
                  <img src={logoutIcon} className="menu-icon-img" />
                  {isExpanded && <span className="menu-text">Logout</span>}
                </div>
              </div>
            </li>
          </ul>
          {/* <h6>Manish Tripathy</h6>
          <p>Head - Customer Service Group</p> */}
        </div>
      )}
    </div>
  );
};

export default Sidebar;
